import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=60a92578"
import script from "./Step.vue?vue&type=script&lang=js"
export * from "./Step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a92578')) {
      api.createRecord('60a92578', component.options)
    } else {
      api.reload('60a92578', component.options)
    }
    module.hot.accept("./Step.vue?vue&type=template&id=60a92578", function () {
      api.rerender('60a92578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/Step.vue"
export default component.exports